<template>
  <label :class="{ inline: inline }">
    <input
      type="checkbox"
      :checked="checked"
      @input="
        $emit('input', $event.target.checked, content)
        checked = !checked
      "
    />
    {{ content }}
    <span v-if="checked" class="checkbox checked" :class="color">
      <img alt="checkmark" :src="require('@/assets/_desktop/_shared/checkbox-mark.svg')" />
    </span>
    <span v-if="!checked" class="checkbox empty" :class="{ reminder: remind }" />
  </label>
</template>

<script>
import ParseFunctions from '@/components/ParseFunctions'
import Constants from '@/components/Constants'

export default {
  mixins: [Constants, ParseFunctions],
  props: {
    content: String,
    remind: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    color: String,
    initialState: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  watch: {
    initialState: function() {
      this.checked = this.initialState
    },
  },
  created() {
    this.checked = this.initialState
  },
  methods: {
    async save() {
      if (!this.dbname) return
      let res = await this.setUserSetting(this.dbname, this.value)
      if (res.status !== 'ok') this.showServerError(res)
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  //display: block;

  //display: inline;
  display: flex;

  &.inline {
    display: inline;
  }

  align-items: center;
  position: relative;
  padding-left: 18px;
  cursor: pointer;
  font-family: $regular;
  font-size: 14px;
  line-height: 20px;
}

.checkbox {
  position: absolute;
  top: 1px;
  left: 0;
  height: 18px;
  width: 18px;
  border-radius: 4px;

  &.empty {
    background-color: white;
    border: solid 1px $flax-bloom;

    &.reminder {
      border-color: $red;
    }
  }

  &.checked {
    &.red {
      background-color: $red;
    }

    &.blue {
      background-color: $blue;
    }

    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    img {
      zoom: 1;
    }
  }
}

/*label input:checked ~ .checkbox { // checked checkbox is colored
    background-color: $red;
    border: 0;
}

.checkbox:after { // hide checkmark
    content: "";
    position: absolute;
    display: none;
}
label input:checked ~ .checkbox:after { // show checkmark
    display: block;
}

label .checkbox:after { // checkmark style
    left: 6px;
    top: 2px;
    width: 6px;
    height: 11px;
    border: solid white;
    border-width: 0 2.3px 2.3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}*/
</style>
